module.exports = __webpack_public_path__ + "static/img/interactivegames2.1e5cd2c6.png";